"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useInterval = void 0;

var react_1 = require("react");
/**
 * A hook for invoking a callback function on a given interval, similar to window.setInterval.
 * @param callback function to be invoked
 * @param delay the interval on which to invoke the callback (ms).
 * @param immediate if true, the callback will be invoked immediately first, and then on every interval
 * @see https://overreacted.io/making-setinterval-declarative-with-react-hooks/
 * @see https://www.aaron-powell.com/posts/2019-09-23-recursive-settimeout-with-react-hooks/
 */


function useInterval(callback, delay, immediate) {
  var savedCallback = react_1.useRef(callback); // Remember the latest callback.

  react_1.useEffect(function () {
    savedCallback.current = callback;
  }); // Execute callback if immediate is set.

  react_1.useEffect(function () {
    if (!immediate) return;
    if (delay === null) return;
    savedCallback.current();
  }, [immediate]); // Set up the timeout loop.
  // useInterval doesn’t wait until the last response is completed before starting another interval timer which can lead to an explosion of concurrent requests if an API has an inconsistent response time
  // Use setTimeout instead of setInterval so that we don't start the timer again until the last iteration has completed.

  react_1.useEffect(function () {
    var id;

    function tick() {
      var ret = savedCallback.current();

      if (ret instanceof Promise) {
        ret.then(function () {
          if (delay !== null) {
            id = setTimeout(tick, delay);
          }
        });
      } else {
        if (delay !== null) {
          id = setTimeout(tick, delay);
        }
      }
    }

    if (delay !== null) {
      id = setTimeout(tick, delay);
      return function () {
        id && clearTimeout(id);
      };
    }
  }, [delay]);
}

exports.useInterval = useInterval;
exports.default = useInterval;